var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 ",class:{hide: !_vm.showForm, 'd-flex justify-content-center': _vm.showForm}},[_c('ChooseDocument')],1)}
var staticRenderFns = []

export { render, staticRenderFns }